module.exports = __webpack_public_path__ + "img/success.e285858e.svg";